<template>
  <WorkPackageSubPageModule
    :workpackage="workpackage"
    :isMobile="isMobile"
    :location="location"
    :loading="loading"
    :background_color="workpackage_bg_hex"
    :foreground_color="workpackage_fg_hex"
    header_icon="check"
    header_text_short="bla"
    header_text_long="blabla"
    @headerBack="$router.push({name: `${location}WorkPackageInfo`, params: { nav_back: $route.params.nav_back} })"
    >
    <template #header-rightside>
      <v-btn class="ma-1" icon :color="workpackage_fg_hex">
        <TIcon name="sign-plus"/>
      </v-btn>
    </template>
    <template #body>
    </template>
  </WorkPackageSubPageModule>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

import { WorkPackageReworkMixin } from '@/mixins/WorkPackageRework.mixin.js'

import WorkPackageSubPageModule from '@/modules/WorkPackageWIP/WorkPackageSubPageModule.module.vue';



  export default {
    components: {
      WorkPackageSubPageModule,
    },
    mixins: [
      WorkPackageReworkMixin
    ],
    props: ['location'],

    data: () => ({
    }),
    created() {
      this.loadData();
    },
    watch: {
      workpackage_id() {
        this.loadData();
      },
    },
    computed: {
      ...mapGetters('Ultra', [
        'getUObjects'
      ]),
    },
    methods: {
      ...mapActions('Ultra', [
        'createUObject',
        'updateUObject',
        'deleteUObject',
        'updateUObjectPosition',
      ]),
      loadData() {
      }
    },
  }
</script>
